export default __webpack_public_path__ + "./images/emptyPublisher.7d62b55e.svg";